// extracted by mini-css-extract-plugin
export default {"alert":"Error_alert__YMVr0","container":"Error_container__ukI11","heading":"Error_heading__pCUtv"};